import {ActivatedRoute, Router} from '@angular/router';
import {Component, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {BaseFormService} from '@services/base-form.service';
import {FazerPedidoIntegralService} from '@services/fazer-pedido-integral.service';
import {catchError, exhaustMap, retry} from 'rxjs/operators';
import {ToastrService} from 'ngx-toastr';
import {concat, interval, of, Subscription, timer} from 'rxjs';
import {FazerPedidoService} from '@services/fazer-pedido.service';
import {GoogleTagManagerEventEnum} from 'src/app/enums/GoogleTagManagerEvent.enum';
import {GoogleTagManagerModel} from 'src/app/models/google-tag-manager.model';
import {TagManagerService} from '@services/tag-manager.service';
import moment from 'moment';
import {ConfigService} from '@services/config.service';
import {CryptoUtils} from '@utils/CryptoUtils';
import {CnpjUtils} from "@utils/cnpj.utils";
import { CalculoErroMensagemUtils } from '@utils/calculo-erro-mensagem.util';
import { LoadingGenericoComponent } from '../../components/loading-generico/loading-generico.component';
import { HeaderComponent } from '../../components/header/header.component';
import { BotaoChatComponent } from '../../components/botao-chat/botao-chat.component';
import { AlertGenericoComponent } from '../../components/alert-generico/alert-generico.component';
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { SelectComponent } from '../../components/select/select.component';
import { TagManagerDirective } from '../../directives/tag-manager.directive';
import { NgxMaskDirective } from 'ngx-mask';
import { FormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';
import { NgxPaginationModule } from 'ngx-pagination';
import { FooterComponent } from '../../components/footer/footer.component';
import { CnpjPipe } from '../../pipes/cnpj.pipe';

@Component({
    selector: 'app-fazer-pedido-integral',
    templateUrl: './fazer-pedido-integral.component.html',
    styleUrls: ['./fazer-pedido-integral.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [LoadingGenericoComponent, HeaderComponent, BotaoChatComponent, AlertGenericoComponent, BreadcrumbComponent, SelectComponent, TagManagerDirective, NgxMaskDirective, FormsModule, NgClass, NgxPaginationModule, FooterComponent, CnpjPipe]
})
export class FazerPedidoIntegralComponent extends BaseFormService implements OnInit, OnDestroy {

  public loadingGenerico = false;
  public checkedCompanyIds = [];
  public allCompaniesChecked: any;
  public allCompaniesSelected: any;
  public selectAll: boolean;
  public listaEmpresas: any [] = [];
  public filteredCompanyList: any [] = [];
  public cnpjFilter: string;
  public statusRC: any = '';
  public flagStatusRC: any = false;
  public empresa: any = localStorage.idEmpresaLogada;
  public currentPage = 1;
  public totalItemsExiba: any;
  public totalItems = this.listaEmpresas.length;
  public itemsPerPage = 5;
  public countStatusTotalEmpresas: any;
  public countStatusTotalProcessados: any;
  public countStatusTotalEmProcessamento: any;
  public countStatusTotalInicio: any;
  public countStatusTotalErro: any;
  public countStatusTotalSemCalculo: any;
  public erro = false;
  public falhaPesquisa = false;
  public mensagemErro: any;
  public subscriptions = new Subscription();
  public filtro = '';
  public statusCalc = "";
  public houveAlteracao: boolean;
  public listaEmpresasParaPedido: any = [];
  public liberaBotaoAvancar = false;
  public listStatusProcessamentoComErro: any = [];
  public necessitaRecalculo: boolean;
  public showModalRecalculo = true;

  public modalRecalculo = {
    buttons: [
      {
        action: () => {
          this.liberaBotaoAvancar = false;
          this.showModalRecalculo = false;
          this.addTagManagerInteractionModal('box:button:click', 'fechar');
        },
        className: 'btn btn-success mx-3',
        text: 'FECHAR',
      },
    ],
    description: 'O tipo de pedido selecionado para Recarga Certa está diferente da sua base atual. ' +
      '' +
      'Utilize o botão de Refazer Cálculo para atualizar.',
    message: 'Recarga Certa divergente do status de cálculo atual',
    type: 'warning',
  };

  constructor(
    private readonly fazerPedidoIntegralService: FazerPedidoIntegralService,
    private readonly router: Router,
    private readonly Toastr: ToastrService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly fazerPedidoService: FazerPedidoService,
    private readonly tagManagerService: TagManagerService,
    private readonly configService: ConfigService
  ) {
    super();
    this.loadQueryParams();
  }

  private loadQueryParams() {
    this.statusRC = this.activatedRoute.snapshot.queryParams.recargaCerta;
  }

  ngOnInit(): void {
    this.countStatusTotalEmpresas = 0;
    this.countStatusTotalProcessados = 0;
    this.countStatusTotalEmProcessamento = 0;
    this.countStatusTotalInicio = 0;
    this.countStatusTotalErro = 0;
    this.countStatusTotalSemCalculo = 0;
    this.showModalRecalculo = true;

    localStorage.listaEmpresaPedido = '';
    this.getAllEmpresasWithCalculationStatus();
    this.addTagManagerScreenView();
    this.getCalculationCounterStatus();
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  onTableAddressClick(idEmpresa, statusCalculo, idPedidoAtivo, flagRecargaCerta) {
    let processamentoAverificar = {};

    const index = this.checkedCompanyIds.indexOf(idEmpresa);
    if (index < 0) {
      this.checkedCompanyIds.push(idEmpresa);
    } else {
      this.checkedCompanyIds.splice(index, 1);
    }
    if (statusCalculo === 'PROCESSADO') {
      const dadosPedido = {
        companyList: [{
          companyDetail: {
            companyId: idEmpresa,
            activeOrderId: idPedidoAtivo,
            flagRecargaCerta: flagRecargaCerta
          },
        }]
      };
      if (index < 0) {
        this.listaEmpresasParaPedido.push(dadosPedido);
      } else {
        this.listaEmpresasParaPedido.splice(index, 1);
      }
    } else {
      processamentoAverificar = {
        id: idEmpresa + '' + idPedidoAtivo,
        status: statusCalculo
      };
      this.verifyObject(processamentoAverificar);
    }

    this.checkRecalculo();

    this.liberaBotaoAvancar = !this.necessitaRecalculo;
    this.allCompaniesChecked = this.checkedCompanyIds.length;
    this.allCompaniesSelected = this.checkedCompanyIds.length === this.totalItemsExiba;
  }

  checkRecalculo() {
    this.necessitaRecalculo = false;
    for (const element of this.listaEmpresasParaPedido) {

      const flag = element.companyList[0].companyDetail.flagRecargaCerta.toString() !== this.statusRC;
      if (flag) {
        this.necessitaRecalculo = true;
        this.addTagManagerInModal();
        break;
      }
    }

    if (!this.necessitaRecalculo) {
      const isInvalidCalcData = this.bloqueiaAvancoPorCalculoDesatualizado;
      if (isInvalidCalcData) {
        this.necessitaRecalculo = true;
        this.addTagManagerInModal();
      }
    }
  }

  selectAllCompanies(event: any) {
    let processamentoAverificar = {};
    if (this.checkedCompanyIds.length === this.listaEmpresas.length || !event.target.checked) {
      this.checkedCompanyIds = [];
      this.listaEmpresasParaPedido = [];
      this.listStatusProcessamentoComErro = [];
      this.liberaBotaoAvancar = false;
    } else {
      this.checkedCompanyIds = [];
      this.listaEmpresasParaPedido = [];
      this.listaEmpresas.forEach(element => {
        this.checkedCompanyIds.push(element.idEmpresa);
        if (element.statusCalculo === 'PROCESSADO') {
          const dadosPedido = {
            companyList: [{
              companyDetail: {
                companyId: element.idEmpresa,
                activeOrderId: element.idPedidoAtivo,
                flagRecargaCerta: element.flagRecargaCerta
              },
            }]
          };
          this.listaEmpresasParaPedido.push(dadosPedido);
        } else {
          processamentoAverificar = {
            id: element.idEmpresa + '' + element.idPedidoAtivo,
            status: element.statusCalculo
          };
          this.verifyObject(processamentoAverificar);
        }

      });
    }
    this.checkRecalculo();
    this.liberaBotaoAvancar = !this.necessitaRecalculo;
    this.allCompaniesSelected = this.checkedCompanyIds.length === this.totalItemsExiba;
  }

  verifyObject(empresa: any) {
    const indexStatusVerify =
      this.listStatusProcessamentoComErro.findIndex(processamento => processamento.id === empresa.id);
    if (indexStatusVerify < 0) {
      this.listStatusProcessamentoComErro.push(empresa);
    } else {
      this.listStatusProcessamentoComErro.splice(indexStatusVerify, 1);
    }
  }

  public avancar() {
    if (this.checkedCompanyIds.length === 0) {
      this.Toastr.error('Selecione uma ou mais empresas!');
    } else {
      this.addTagInAvancar();
      localStorage.listaEmpresaPedido = JSON.stringify(this.listaEmpresasParaPedido);
      this.router.navigate(['/fazer-pedido'], {
        queryParams: {
          recargaCerta: this.statusRC,
        }
      });
    }
  }

  get bloqueiaAvancoPorCalculoDesatualizado(): boolean {
    if (this.checkedCompanyIds.length === 0) {
      return false;
    }

    const hoje = moment().startOf('day');

    let flag = false;
    for (const idEmpresa of this.checkedCompanyIds) {
      const empresa = this.listaEmpresas.find(e => e.idEmpresa === idEmpresa);
      if (!empresa) return true;

      if (empresa.statusCalculo !== 'PROCESSADO') return true;
      if (!empresa.dataCalculo) return true;

      const dataCalculo = moment(
        empresa.dataCalculo,
        [
          'DD/MM/YYYY HH:mm:ss',
          'DD/MM/YYYY HH:mm',
          'DD/MM/YYYY',
          'YYYY-MM-DD HH:mm:ss',
          'YYYY-MM-DD HH:mm',
          'YYYY-MM-DD'
        ],
        true
      ).startOf('day');

      if (!dataCalculo.isValid() || !dataCalculo.isSame(hoje, 'day')) {
        flag = true;
        break;
      }
    }

    return flag;
  }

  get motivoBloqueioAvancoPorCalculoDesatualizado(): string | null {
    if (!this.bloqueiaAvancoPorCalculoDesatualizado) {
      return null;
    }

    return 'Para avançar, selecione apenas empresas com status PROCESSADO e com Data do Cálculo de hoje. Clique em "Refazer Cálculo".';
  }

  isChecked(idEmpresa) {
    const index = this.checkedCompanyIds.indexOf(idEmpresa);
    return (index >= 0);
  }

  public onItemsPerPageChange(qtItems: any) {
    this.itemsPerPage = qtItems;
    this.getPage(1);
  }

  public getPage(page: number) {
    this.currentPage = page;
  }

  public companyFilter() {
    this.getPage(1);

    this.cnpjFilter = CnpjUtils.normalize(this.cnpjFilter);
    const isSearchTextEmpty = !this.cnpjFilter || this.cnpjFilter.length === 0;

    this.filteredCompanyList = isSearchTextEmpty
      ? this.listaEmpresas
      : this.filterCompaniesByCNPJ();

    this.totalItemsExiba = this.filteredCompanyList.length;
  }

  private filterCompaniesByCNPJ() {
    return this.listaEmpresas.filter(company => company.cnpj.match(this.cnpjFilter));
  }

  public getCalculationCounterStatus() {
    let isFirstLoad = true;
    let firstTime = 2000;
    if (this.checkedCompanyIds.length >= 10) {
      firstTime = 6000;
    }
    const subscription = concat(timer(firstTime), timer(firstTime), timer(firstTime), interval(5000))
      .pipe(
        exhaustMap(() =>
          this.fazerPedidoIntegralService.getCalculationCounterStatus(this.empresa).pipe(
            retry(3),
            catchError(error => {
              console.error('Erro ao obter status:', error);
              this.showMsgErrorCalc();
              return of(null);
            })
          )
        )
      )
      .subscribe({
        next: (response: any) => {
          if (!response?.response) return;

          const data = response.response;
          this.erro = false;

          let houveAlteracaoStatus = false;
          if (!isFirstLoad) {
            houveAlteracaoStatus = this.houveAlteracaoCalculos(data);
          }

          this.updateConteudoCalculoAndamento(data);
          if (houveAlteracaoStatus) {
            this.alteraStatusCalculoEmpresasSelecionadas();
          }
          this.checaProcessamentoFinalizou(data, subscription);
          isFirstLoad = false;
        },
        error: (error: any) => {
          this.showMsgErrorCalc();
          console.error(error);
        }
      });
    this.subscriptions.add(subscription);
  }

  public alteraStatusCalculoEmpresasSelecionadas(): void {
    this.checkedCompanyIds.forEach(idEmpresa => {
      const empresa = this.listaEmpresas.find(emp => emp.idEmpresa === idEmpresa);
      if (empresa) {
        empresa.statusCalculo = 'PROCESSANDO';
        empresa.valorTotal = 'R$ 0,00';
        empresa.flagRecargaCerta = this.statusRC === 'true';
      }
    });
  }

  private checaProcessamentoFinalizou(response: any, subscription: any) {
    if ((response.totalEmProcessamento === 0 && response.totalInicio === 0) &&
      (response.totalEmpresas === (response.totalProcessados + response.totalErro + response.totalSemCalculo))) {

      this.statusCalc = "FINALIZADO";
      this.getProcessamentoCalculosEmpresa();
      subscription.unsubscribe();
    }
  }

  private updateConteudoCalculoAndamento(response: any): void {

    this.countStatusTotalEmpresas = response.totalEmpresas;
    this.countStatusTotalProcessados = response.totalProcessados;
    this.countStatusTotalEmProcessamento = response.totalEmProcessamento;
    this.countStatusTotalInicio = response.totalInicio;
    this.countStatusTotalErro = response.totalErro;
    this.countStatusTotalSemCalculo = response.totalSemCalculo;
  }

  private houveAlteracaoCalculos(response: any): boolean {

    let houveAlteracaoStatus = this.countStatusTotalEmpresas !== response.totalEmpresas ||
      this.countStatusTotalProcessados !== response.totalProcessados ||
      this.countStatusTotalEmProcessamento !== response.totalEmProcessamento ||
      this.countStatusTotalInicio !== response.totalInicio ||
      this.countStatusTotalErro !== response.totalErro ||
      this.countStatusTotalSemCalculo !== response.totalSemCalculo;

    if (houveAlteracaoStatus) {
      this.statusCalc = "ANDAMENTO";
      this.houveAlteracao = true;
    }

    return houveAlteracaoStatus;
  }

  filtrar() {
    this.getStatusEmp();
  }

  public getAllEmpresasWithCalculationStatus() {
    this.loadingGenerico = true;
    this.statusCalc = "INICIO";
    this.houveAlteracao = false;
    const subscription = interval(5000)
      .pipe(
        exhaustMap(() => this.fazerPedidoIntegralService.getAllEmpresasWithCalculationStatus(this.empresa, this.filtro).pipe(
            catchError(error => {
              this.erro = true;
              console.error('Erro ao obter valores:', error);
              return of(null);
            })
          )
        )).subscribe(
        (response: any) => {
          this.processResponseCalculationDetail(response, subscription);
        }
      );

    this.subscriptions.add(subscription);
  }

  getProcessamentoCalculosEmpresa() {

    this.fazerPedidoIntegralService.getAllEmpresasWithCalculationStatus(this.empresa, this.filtro)
    .subscribe({
      next: (response: any) => {
        this.processResponseCalculationDetail(response, null);
      },
      error: (error: any) => {
        console.error(error);
      }
    });
  }

  private processResponseCalculationDetail(response: any, subscription: any) {

    if (response?.response) {
      if (subscription != null) {
        if (this.countStatusTotalEmProcessamento === 0) {
          this.loadingGenerico = false;
          this.statusCalc = "";
          this.houveAlteracao = false;
        }
        subscription.unsubscribe();
      }
      this.atualizaIdPedidoAtivoPosRecalculo(response);
      this.erro = false;
      this.listaEmpresas = response.response.empresas;
      this.flagStatusRC = response.response.empresaRecargaCerta;
      this.totalItemsExiba = response.response.empresas.length;
      this.liberaBotaoAvancar = this.habilitaBotaoAvancarAposRecalculo() && this.verificaMudancaNosStatusProcessamento();

      this.companyFilter();
      if (this.statusCalc === "FINALIZADO") {
        this.loadingGenerico = false;
        this.houveAlteracao = false;
      }
    } else {
      this.erro = true;
    }
  }

  atualizaIdPedidoAtivoPosRecalculo(response: any) {
    response.response.empresas.forEach(empresa => {
      const empresaParaAtualizar = this.listaEmpresasParaPedido.find(dadosPedido =>
        dadosPedido.companyList[0].companyDetail.companyId === empresa.idEmpresa
      );
      if (empresaParaAtualizar) {
        empresaParaAtualizar.companyList[0].companyDetail.activeOrderId = empresa.idPedidoAtivo;
        empresaParaAtualizar.companyList[0].companyDetail.flagRecargaCerta = empresa.flagRecargaCerta;
      }
    });
  }

  verificaMudancaNosStatusProcessamento() {
    for (const empresa of this.listaEmpresas) {
      if (this.checkedCompanyIds.includes(empresa.idEmpresa)) {
        if (empresa.statusCalculo !== 'PROCESSADO') {
          return false;
        }
      }
    }
    return true;
  }

  habilitaBotaoAvancarAposRecalculo() {

    const companyIds = new Set();
    for (const item of this.listaEmpresasParaPedido) {
      if (item.companyList) {
        for (const company of item.companyList) {
          if (company.companyDetail) {
            companyIds.add(company.companyDetail.companyId);
          }
        }
      }
    }

    for (const id of this.checkedCompanyIds) {
      if (!companyIds.has(id)) {
        return false;
      }
    }
    return true;
  }

  public refazerCalculo() {
    if (this.checkedCompanyIds.length === 0) {
      this.Toastr.error('Selecione uma ou mais empresas!');
    } else {
      this.loadingGenerico = true;
      this.liberaBotaoAvancar = false;
      this.statusCalc = "INICIO";
      this.fazerPedidoService.getInicioCalculoValoresPost(this.empresa, this.checkedCompanyIds, '', this.statusRC)
        .subscribe({
          next: (response: any) => {
            if (response.status === 'OK') {
              this.getCalculationCounterStatus();
            }
          },
          error: (error: any) => {
            console.error(error);
            this.showMsgErrorCalc();
          }
        });
    }
  }

  private showMsgErrorCalc() {
    this.loadingGenerico = false;
    this.Toastr.error('Não foi possível Refazer Cálculo, tente novamente!', '', {timeOut: 7000});
  }

  public getStatusEmp() {
    this.loadingGenerico = true;
    this.statusCalc = "INICIO";
    const subscription = interval(5000)
      .pipe(
        exhaustMap(() => this.fazerPedidoIntegralService.getAllEmpresasWithCalculationStatus(this.empresa, this.filtro).pipe(
          retry(3),
          catchError(error => {
            this.erro = true;
            console.error('Erro ao obter valores:', error);
            return of(null);
          })
        ))).subscribe(
        (success: any) => {
          subscription.unsubscribe();
          this.erro = false;
          this.loadingGenerico = false;
          this.listaEmpresas = success.response.empresas;
          this.companyFilter();
        });

    this.subscriptions.add(subscription);
  }

  addTagManagerInModal(): void {
    if (this.showModalRecalculo && this.necessitaRecalculo) {
      this.addTagManagerScreenViewModal();
    }
  }

  addTagManagerScreenViewModal() {
    const model = this.addTagManagerModal(GoogleTagManagerEventEnum.screenView);
    this.tagManagerService.pushTag(model);
  }

  addTagManagerInteractionModal(elementType: string, elementContent: string) {
    const model = this.addTagManagerModal(GoogleTagManagerEventEnum.interaction, elementType, elementContent);
    this.tagManagerService.pushTag(model);
  }

  private addTagManagerModal(event: GoogleTagManagerEventEnum, elementType: string = null,
                             elementContent: string = null): GoogleTagManagerModel {
    const model: GoogleTagManagerModel = new GoogleTagManagerModel();
    model.event = event;
    model.element_type = elementType;
    model.element_content = `none:${elementContent}:none`;
    model.section_app = 'fazer-pedido';
    model.screen_name = 'fazer-pedido:recarga-certa-divergente';
    model.screen_type = 'modal';
    return model;
  }

  addTagManagerScreenView() {
    const model = this.addTagManager(GoogleTagManagerEventEnum.screenView, null, null);
    this.tagManagerService.pushTag(model);
  }

  addTagManagerInteraction(elementType: string, elementContent: string): GoogleTagManagerModel {
    return this.addTagManager(GoogleTagManagerEventEnum.interaction, elementType, elementContent);
  }

  private addTagManager(event: GoogleTagManagerEventEnum,
                        elementType: string, elementContent: string): GoogleTagManagerModel {
    const model: GoogleTagManagerModel = new GoogleTagManagerModel();
    model.event = event;
    model.element_type = elementType;
    model.element_content = `none:${elementContent}:none`;
    model.section_app = 'fazer-pedido';
    model.screen_name = 'fazer-pedido:home';
    model.screen_type = 'pagina';
    return model;
  }

  addTagManagerInteractionAndPush(elementType: string, elementContent: string): GoogleTagManagerModel {
    return this.addTagManager(GoogleTagManagerEventEnum.interaction, elementType, elementContent);
  }

  addTagInCheck(flagRecargaCerta: boolean, data: string) {
    const elementFormat = this.getElementFormat(flagRecargaCerta, data);
    const model = this.addTagManagerInteraction('select:checkbox:click', elementFormat);
    model.element_content = `none:${elementFormat}:checkbox`;
    this.tagManagerService.pushTag(model);
  }

  getElementFormat(flagRecargaCerta: boolean, data: string, cnpj: string = null) {
    let cnpjHash = '';
    if (cnpj !== null) {
      const salt = this.configService.getConfig().GA_SALT_CODE;
      cnpjHash = CryptoUtils.hashWithSaltCode(cnpj, salt) + '&';
    }
    const recargaCerta = this.flagStatusRC === true && flagRecargaCerta ? 'sim' : 'nao';
    const dataFormatada = data.replace(/[/:]/g, '').replace(' ', '-');
    return `${cnpjHash}recarga-certa-${recargaCerta}&data-calculo-${dataFormatada}`;
  }

  addTagInAvancar() {
    for (const checked of this.checkedCompanyIds) {
      const empresa = this.listaEmpresas.find(x => x.idEmpresa === checked);
      const elementFormat = this.getElementFormat(empresa.flagRecargaCerta, empresa.dataCalculo, empresa.cnpj);
      const model = this.addTagManagerInteraction('box:button:click', elementFormat);
      model.element_content = `none:${elementFormat}:avancar`;
      this.tagManagerService.pushTag(model);
    }
  }

  obterMensagemErroCalculo(mensagem: string): string {
    return CalculoErroMensagemUtils.formatar(mensagem);
  }

}
